/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class RejectIcon extends BaseIcon {
  getChildren = () => {
    const color = this.getColor() === 'currentColor' ? '#e96363' : this.getColor()
    return [
      <g>
        <path fill={color}
          fillRule='evenodd'
          clipRule='evenodd'
          d="M6.978,13.971 C3.117,13.971 -0.012,10.842 -0.012,6.981 C-0.012,3.120 3.117,-0.009 6.978,-0.009 C10.839,-0.009 13.968,3.120 13.968,6.981 C13.968,10.842 10.839,13.971 6.978,13.971 ZM11.000,6.000 L3.000,6.000 C2.448,6.000 2.000,6.448 2.000,7.000 C2.000,7.552 2.448,8.000 3.000,8.000 L11.000,8.000 C11.552,8.000 12.000,7.552 12.000,7.000 C12.000,6.448 11.552,6.000 11.000,6.000 Z" />
      </g>
    ]
  }
  getViewBox = () => '0 0 16 16'
}
